






























































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import IZoom from '@/components/icons/IZoom.vue'
import IRotate from '@/components/icons/IRotate.vue'
import IArrow from '@/components/icons/IArrow.vue'

@Component({
  name: "image-view",
  components: {
    'i-zoom': IZoom,
    'i-rotate': IRotate,
    'i-arrow': IArrow,
  }
})
export default class ImageView extends Vue {
  @Prop({type: [Array], default: []}) protected images!: any
  @Prop({type: [Boolean], default: true}) protected isZoom!: boolean
  @Prop({type: [String], default: ''}) protected title!: string

  zoom:number = 100
  imageWidth:number = 0
  link:string = ''
  isMouseDown:boolean = false
  dragObj:any = []
  xOffset:number = 0
  yOffset:number = 0
  blockLeft:number = 0
  blockTop:number = 0
  isFirstTranslate:boolean = true
  currentIndex:number = 0

  mounted() {
    let img = (document.querySelector('.lfs-img-view-block-img') as HTMLElement)
    this.imageWidth = img.clientWidth
    this.isFirstTranslate = true
  }

  @Watch('images')
  resetZoom() {
    console.log(this.images)
    let img = (document.querySelector('.lfs-img-view-block-img-background') as HTMLElement)
    this.zoom = 100    
    this.isFirstTranslate = true
    img.style.width = '100%'
    img.style.left = `0px`
    img.style.top = `0px`
    img.style.transform = ''
  }

  rotate(side:string) {
    let elem =  (document.querySelector('.lfs-img-view-block-img-background') as HTMLElement)
    let transform = elem.style.transform
    let start = transform.indexOf('(')
    let end = transform.indexOf('d')
    if(side == 'right') {
      elem.style.transform = `rotate(${+transform.substring(++start, end) + 90}deg)`
    } else { 
      elem.style.transform = `rotate(${+transform.substring(++start, end) - 90}deg)`
    }
  }

  changeIndex(prop:any) {
    if(prop == 'prev') {
      if(this.currentIndex == 0) {
        this.currentIndex = this.images.length - 1
      } else {
        this.currentIndex--
      }
    } else if (prop == 'next'){
      if(this.currentIndex == this.images.length - 1) {
        this.currentIndex = 0
      } else {
        this.currentIndex++
      }
    } else {
      this.currentIndex = prop
    }
    let img = (document.querySelector('.lfs-img-view-block-img-background') as HTMLElement)
    this.zoom = 100
    this.isFirstTranslate = true
    img.style.width = '100%'
    img.style.left = `0px`
    img.style.top = `0px`
    img.style.transform = ''
  }

  changeZoom(prop:string) {
    let img = (document.querySelector('.lfs-img-view-block-img-background') as HTMLElement)
    if (prop == 'plus' && this.zoom < 200) {
      this.zoom += 25
    } else if (prop == 'minus' && this.zoom > 100) {
      this.zoom -= 25
      this.isFirstTranslate = true
    } 
    let transform = img.style.transform
    img.style.width = this.zoom + '%'
    img.style.height = this.zoom + '%'
    if(this.isFirstTranslate) {
      img.style.position = 'absolute'
      img.style.left = `calc(50% - ${img.clientWidth / 2}px)`
      img.style.top = `calc(50% - ${img.clientHeight / 2}px)`
    }
  }

  mouseDown(e:any) {
    if(this.zoom != 100) {
      let block = (document.querySelector('.lfs-img-view-block-img') as HTMLElement).getBoundingClientRect()
      this.blockLeft = block.left
      this.blockTop = block.top
      this.isMouseDown = true
      this.dragObj = e.target
      this.dragObj.style.position = "absolute"
      let rect = this.dragObj.getBoundingClientRect()
      this.xOffset = e.clientX - rect.left
      this.yOffset = e.clientY - rect.top
      this.isFirstTranslate = false
    }
  }

  mouseMove(e:any) {
    if(this.isMouseDown) {
      this.dragObj.style.left = e.clientX - this.blockLeft - this.xOffset +"px"
		  this.dragObj.style.top = e.clientY - this.blockTop - this.yOffset +"px"
    }
  }

  mouseUp() {
    this.isMouseDown = false
  }
}
